const companyGroup = company => company?.type === 'Vendor' ? 'vendors' : ['Client', 'Customer'].includes(company?.type) ? 'clients' : 'other';
function recordGroup(data, type, record) {
    if (type === 'companies') return companyGroup(record);
    const company = data.companies.find(item => item.id === record.companyId);
    if (record.contactType === 'Client' || ['client', 'client_and_vendor'].includes(record.sourceProfile?.relationship) || companyGroup(company) === 'clients') return 'clients';
    return record.contactType === 'Vendor' && companyGroup(company) === 'vendors' ? 'vendors' : 'other';
}
const GROUP_LABELS = { vendors: 'Vendors', clients: 'Clients', other: 'Other relationships' };
module.exports = { companyGroup, recordGroup, GROUP_LABELS };
